import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { TagState, UserState } from '@/states'
import { List } from '@/controllers/tag'

const useTags = () => {
    const { SetState, Loading } = TagState()
    const { User } = UserState()
    const { push, pathname } = useRouter()

    useEffect(() => {
        if (User && !Loading) List(SetState, push)
    }, [User, pathname])
}

export default useTags
